import config, { getBrandingConfig } from "@/config";

export const ConfigPlugin = {
  install(Vue) {
    Vue.prototype.$config = {
      ...config,
      get branding() {
        return getBrandingConfig();
      },
    };
  },
};
